<template>
  <div class="itinerary-control">
    <div
      v-for="(group, index) in value"
      :key="index"
      :class="[`day-${index + 1}`]"
    >
      <h4 class="day-title">
        Day {{ index + 1
        }}<span class="delete-link" @click="onClickDeleteDay(index)"
          >Delete Day</span
        >
      </h4>
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`title-day-${index + 1}`"
          >Title</label
        >
        <div class="col-md-10">
          <input
            type="text"
            class="form-control"
            :id="`title-day-${index + 1}`"
            v-model="group.title"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`description-day-${index + 1}`"
          >Description*</label
        >
        <div class="col-md-10">
          <textarea
            type="text"
            class="form-control"
            :id="`description-day-${index + 1}`"
            v-model="group.description"
            rows="4"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`experiences-day-${index + 1}`"
          >Experiences</label
        >
        <div class="col-md-10">
          <ExperiencePicker v-model="group.items" />
        </div>
      </div>
    </div>
    <AddContentButton color="#c32aa3" @click="onClickAddDay"
      >Add Day</AddContentButton
    >

    <v-dialog v-model="showConfirmDeleteDialog" width="400">
      <v-card>
        <v-card-text>
          <div style="padding: 25px 0 0; font-size: 14px">
            Do you want to delete this day?
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="d-flex justify-space-between" style="width: 100%">
            <div
              class="btn btn-primary"
              @click="onClickConfirmDelete"
              style="width: 48%; padding: 10px"
            >
              Delete
            </div>
            <div
              class="btn btn-secondary"
              @click="onClickCancelDeleteDay"
              style="width: 48%; padding: 10px"
            >
              Cancel
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AddContentButton from "@/components/AddContentButton";
import ExperiencePicker from "@/components/ExperiencePicker";
export default {
  components: {
    AddContentButton,
    ExperiencePicker,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showConfirmDeleteDialog: false,
      selectedDay: -1,
    };
  },
  methods: {
    onClickAddDay() {
      this.value.push({
        title: "",
        description: "",
        items: [],
      });
    },
    onClickDeleteDay(index) {
      this.selectedDay = index;
      this.showConfirmDeleteDialog = true;
    },
    onClickCancelDeleteDay() {
      this.closeConfirmDeleteDialog();
    },
    onClickConfirmDelete() {
      if (this.selectedDay < 0) return;

      this.value.splice(this.selectedDay, 1);
      this.closeConfirmDeleteDialog();
    },
    closeConfirmDeleteDialog() {
      this.showConfirmDeleteDialog = false;
      this.selectedDay = -1;
    },
  },
};
</script>

<style lang="scss">
.itinerary-control {
  .day-title {
    color: var(--color-purple);
    font-size: 1.125rem;
    font-weight: bold;

    .delete-link {
      text-decoration: underline;
      text-transform: uppercase;
      color: white;
      font-weight: normal;
      font-size: 12px;
      float: right;
      cursor: pointer;
    }

    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }
}
</style>
